import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'modal'
  ]

  applyPreset(event) {
    const { hfo, lsfo, mgo, tce, euets } = event.currentTarget.dataset

    // TODO: this could maybe be done as a target in the market rates form
    // Disable submit button
    document.querySelector("input[name='market_rates[hfo]']").value = hfo;
    document.querySelector("input[name='market_rates[lsfo]']").value = lsfo;
    document.querySelector("input[name='market_rates[mgo]']").value = mgo;
    document.querySelector("input[name='market_rates[tce]']").value = tce;
    document.querySelector("input[name='market_rates[eu_ets]']").value = euets;
    // Enable submit button
    document.querySelector(".market-rate-wrapper input[type='submit']").disabled = false;

    this.closeModal()
  }

  closeModal() {
    bootstrap.Modal.getInstance(this.modalTarget)?.hide();
  }
}